const initState = [];

const studentsNew = (state = initState, action) => {
  switch (action.type) {
    case 'STUDENT_LIST_NEW':
      console.log(`STUDENT_LIST_NEW`);
      return action.payload;
    default:
      return state;
  }
};

export default studentsNew;
